import { Canvas } from '@react-three/fiber';
import { GlobeScene } from './GlobeScene';

export function WorldCanvas() {
    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: -1 }}>
            <Canvas
                camera={{ fov: 75, near: 0.1, far: 1000, position: [30, 0, 0] }}
                gl={{ antialias: true }}
                onCreated={({ gl }) => { gl.setClearColor(0x000011); }}
            >
                <GlobeScene />
            </Canvas>
        </div>
    );
}
